export default "__VITE_ASSET__89bcbd6a__"